import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Alert,
} from '@mui/material';
import LocationOffIcon from '@mui/icons-material/LocationOff';

/** Dialog บล็อกลงเวลาออก — โครงการนี้บังคับต้องอยู่ในพื้นที่ GPS (ไม่มีปุ่มข้าม) */
export default function CheckoutGpsBlockDialog({ open, reason, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LocationOffIcon color="error" />
        <Typography fontWeight={700}>ลงเวลาออกไม่ได้</Typography>
      </DialogTitle>
      <DialogContent>
        <Alert severity="error">{reason}</Alert>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
